<template>
  <v-navigation-drawer
    v-model="isMenuActive"
    class="nav-drawer text-left"
    bottom
    temporary
    width="300"
  >
    <v-list>
      <v-list-item
        prepend-icon="$apiKeys"
        title="API Keys"
        :to="{ name: 'keys' }"
      />

      <v-spacer />

      <v-divider />

      <v-list-item prepend-icon="$signOut" @click="auth.signOut">
        Sign Out
      </v-list-item>
      <SfiThemeToggle rounded="0" />
    </v-list>
  </v-navigation-drawer>
</template>

<script lang="ts" setup>
import { useAuth } from '@simplifi/auth'
import { useNav } from '@simplifi/components'

const { isMenuActive } = useNav()

const auth = useAuth()
</script>

<style scoped>
/* Style list as flex so we can push things to the bottom easily */
/* Also allow overflow-y so if the menu gets large / used on mobile we can scroll it */
.v-list {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  overflow-y: auto !important;
  padding: 0;
}
/* Prevent menu items being visually selectable */
.v-list-item-title {
  user-select: none;
}
</style>
